import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type UserInfo as SchemaUserInfo } from '../schemas/UserInfo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetUserInfoContentType = '' as const;
export type GetUserInfoRequest = void;
export type GetUserInfoResponses = LinkCommonErrorResponses & {
    /**
     * @description Get user with stores
     */
    '200': {
        'application/json': SchemaUserInfo;
    };
};
export type GetUserInfoResponseSuccess = GetUserInfoResponses['200']['application/json'];
export type GetUserInfoSearchParams = undefined;
export type GetUserInfoPathParameters = undefined;
export const GetUserInfoUrl = '/user/info' as const;
export const GetUserInfoMethod = 'GET' as const;
export const getGetUserInfoUrl = (_params?: GetUserInfoPathParameters) => GetUserInfoUrl;
